import { useAtomValue } from "jotai";
import useSWRImmutable from "swr/immutable";

import { JWTExpiryThreshold, JWTRefreshSWRKey } from "~/components/header/consts";
import { refreshToken } from "~/lib/account/apis";
import { accountAtom } from "~/lib/account/atoms";

export const useRefreshToken = () => {
  const { accessTokenExpiryTime, isLoggedIn, pianoUser, user } = useAtomValue(accountAtom);

  const isJWTExpired = () =>
    ((accessTokenExpiryTime ?? 0) - JWTExpiryThreshold) * 1000 - Date.now() < 0;

  const isNeedToRefreshToken = () =>
    !!user &&
    (!pianoUser ||
      !user.source ||
      !user.created ||
      !user.useremail ||
      !user.uuid ||
      user.useremail !== pianoUser.email ||
      user.uuid !== pianoUser.sub);

  useSWRImmutable(() => (isLoggedIn ? JWTRefreshSWRKey : null), refreshToken, {
    isPaused: () => !(isNeedToRefreshToken() || isJWTExpired()),
    refreshInterval: 5000,
    revalidateOnMount: true,
  });
};
